import React, {memo} from "react"
import {Handle, Position} from "@xyflow/react"
import Tooltip from "../Tooltip"
import {SECTION_COLOR, SECTION_TEXT_COLOR} from "../FlowPage"

export default memo(({data}) => {
    const size = data.size
    const width = size?.width || 200
    const height = size?.height || 60

    return (
        <Tooltip id={data.id}>
            <div
                className="flexRow center"
                style={{
                    position: "relative", // for the handle to be positioned correctly
                    width,
                    height,
                    border: "1px solid #333",
                    fontSize: "16px",
                    color: SECTION_TEXT_COLOR,
                    backgroundColor: SECTION_COLOR
                }}
            >
				<span style={{marginLeft: 10}}>
					{data.label}
				</span>
                <Handle type="source" position={Position.Bottom} id="a"/>
            </div>
        </Tooltip>
    )
})
